// Copyright 2025, Imprivata, Inc.  All rights reserved.

import { useMutation } from '@tanstack/react-query';

import { changePasswordWithEncryption } from '@api/selfServiceServices';

export type ChangePasswordParams = { newPassword: string };

export const useChangePassword = () => {
  return useMutation<void, Error, ChangePasswordParams>({
    mutationFn: (params: ChangePasswordParams) => changePasswordWithEncryption(params.newPassword),
  });
};
